"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZOOM_HEIGHT = exports.ZOOM_WIDTH = exports.CSS = void 0;
const image_button_1 = require("../../components/button/image.button");
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-CollectionEdit',
    isMissing: 'c-CollectionEdit--is-missing',
    isLoading: 'c-CollectionEdit--is-loading',
    isEmpty: 'c-CollectionEdit--empty',
    leftIcon: 'c-CollectionEdit__Icon',
    title: {
        container: 'c-CollectionEditTitle',
        tools: 'c-CollectionEditTitle__Tools',
        save: 'c-CollectionEditTitle__Save',
        discard: 'c-CollectionEditTitle__Discard',
        title: 'c-CollectionEditTitle__Text',
        form: 'c-CollectionEditTitle__Form',
        isInvalid: 'c-CollectionEditTitle--invalid',
    },
    zoom: 'c-CollectionEditTitle__Zoom',
    field: {
        container: 'c-CollectionField',
        summary: 'c-CollectionField__Summary',
        detail: 'c-CollectionField__Detail',
        title: 'c-CollectionField__Title',
        value: 'c-CollectionField__Value',
        isImageUpload: 'c-CollectionFiled__ImageUpload',
        colorIndicator: 'c-CollectionField__ColorIndicator',
        redDot: 'c-CollectionField__RedDot',
    },
    form: {
        container: 'c-SubForm',
        header: 'c-SubForm__Header',
        title: 'c-SubForm__Title',
        tools: 'c-SubForm__Tools',
        footer: 'c-SubForm__Footer',
        footerButton: 'c-SubForm__FooterButton',
        titleName: 'c-SubForm__TitleName',
        titleCount: 'c-SubForm__TitleCount',
        actions: 'c-SubForm__Actions',
        isRoot: 'c-SubForm--is-root',
    },
    instance: {
        container: 'c-SubFormInstance',
        header: 'c-SubFormInstance__Header',
        icon: 'c-SubFormInstance_Icon',
        title: 'c-SubFormInstance_Title',
        tools: 'c-SubFormInstance___Tools',
        text: 'c-SubFormInstance_Text',
        isOpen: 'c-SubFormInstance--is-open',
    },
};
exports.ZOOM_WIDTH = '460px';
exports.ZOOM_HEIGHT = '200px';
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'white-space': 'nowrap',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        display: 'flex',
        'flex-direction': 'column',
        width: '100%',
        height: '100%',
        'max-height': '100%',
        'border-left': '1px solid ' + theme_1.DefaultTheme.font.color.divider,
        'border-right': '1px solid ' + theme_1.DefaultTheme.font.color.divider,
    },
    [exports.CSS.isMissing]: {
        'align-items': 'center',
        'justify-content': 'center',
    },
    [exports.CSS.isLoading]: {
        'align-items': 'center',
        'justify-content': 'center',
    },
    [exports.CSS.title.container]: {
        display: 'flex',
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'align-items': 'center',
        'justify-content': 'space-between',
        padding: '4px',
        height: theme_1.DefaultTheme.space(6),
        'min-height': theme_1.DefaultTheme.space(6),
        'line-height': theme_1.DefaultTheme.space(6),
        'border-bottom': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
    },
    [exports.CSS.title.save]: {
        color: theme_1.DefaultTheme.color.accent,
    },
    [exports.CSS.title.title]: {
        'text-transform': 'inherit',
        'font-weight': 'inherit',
        'font-family': 'inherit',
    },
    [exports.CSS.zoom]: {
        height: exports.ZOOM_HEIGHT,
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'flex-shrink': 0,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'box-shadow': theme_1.DefaultTheme.shadow.box.bottom,
    },
    [exports.CSS.field.title]: {
        flex: '1 0 30%',
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
    },
    [exports.CSS.field.value]: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme_1.DefaultTheme.font.color.supporting,
        overflow: 'hidden',
        width: '100%',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
    },
    [exports.CSS.field.isImageUpload]: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        height: '20px',
        width: '20px',
        'min-width': '20px',
        'margin-left': theme_1.DefaultTheme.space(1),
        'margin-right': theme_1.DefaultTheme.space(1),
    },
    [exports.CSS.field.colorIndicator]: {
        height: theme_1.DefaultTheme.space(3),
        width: theme_1.DefaultTheme.space(3),
        borderRadius: '50%',
        marginRight: '38px',
    },
    [exports.CSS.field.container]: {
        padding: '4px ' + theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.field.summary]: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        [`& .${image_button_1.CSS.container}`]: {
            height: '20px',
            width: '20px',
            'min-width': '20px',
            'margin-left': theme_1.DefaultTheme.space(1),
        },
    },
    [exports.CSS.field.detail]: {
        'margin-top': theme_1.DefaultTheme.space(1),
        'border-left': '2px solid ' + theme_1.DefaultTheme.font.color.divider,
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
    },
    [exports.CSS.form.container]: {
        padding: '8px 0px 4px 0',
    },
    [exports.CSS.form.isRoot]: {
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
    },
    [exports.CSS.form.header]: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        padding: `0 ${theme_1.DefaultTheme.space(2)}`,
        [`& .${exports.CSS.form.tools}`]: {
            display: 'none',
        },
        [`&:hover .${exports.CSS.form.tools}`]: {
            display: 'flex',
        },
    },
    [exports.CSS.form.title]: {
        'font-weight': 'bold',
        display: 'flex',
    },
    [exports.CSS.form.tools]: {
        [`& .${image_button_1.CSS.container}`]: {
            height: '20px',
            width: '20px',
            'min-width': '20px',
            'padding-left': theme_1.DefaultTheme.space(1),
        },
    },
    [exports.CSS.form.footer]: {
        'margin-left': theme_1.DefaultTheme.space(2),
        display: 'flex',
        'justify-content': 'space-between',
    },
    [exports.CSS.form.footerButton]: {
        display: 'flex',
        'align-items': 'center',
        'margin-right': theme_1.DefaultTheme.space(2),
        'font-weight': 'normal',
        'text-transform': 'none',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        color: theme_1.DefaultTheme.font.color.supporting,
        '&:hover': {
            color: theme_1.DefaultTheme.font.color.primary,
        },
        '& i': {
            'padding-right': theme_1.DefaultTheme.space(1),
        },
    },
    [exports.CSS.form.titleCount]: {
        'margin-left': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.color.accent,
    },
    [exports.CSS.instance.container]: {
        'margin-left': theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.instance.header]: {
        display: 'flex',
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'align-items': 'center',
        'justify-content': 'space-between',
        padding: `${theme_1.DefaultTheme.space(2)} 0 ${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(2)}`,
        height: theme_1.DefaultTheme.space(6),
        'line-height': theme_1.DefaultTheme.space(6),
        cursor: 'pointer',
        'border-left': '2px solid ' + theme_1.DefaultTheme.background.lightGrey,
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.grey,
            'border-left': '2px solid ' + theme_1.DefaultTheme.color.accent,
        },
        [`& .${exports.CSS.instance.tools}`]: {
            display: 'none',
        },
        [`&:hover .${exports.CSS.instance.tools}`]: {
            display: 'flex',
        },
    },
    [exports.CSS.instance.icon]: {
        width: theme_1.DefaultTheme.space(8),
        position: 'absolute',
        left: '-36px',
    },
    [exports.CSS.instance.isOpen]: {
        'margin-top': '12px',
        'margin-bottom': '8px',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
    },
    [exports.CSS.instance.title]: {
        display: 'flex',
        'align-items': 'center',
        position: 'relative',
    },
    [exports.CSS.instance.text]: {
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
    },
    [exports.CSS.field.redDot]: {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        'border-radius': '50%',
        'background-color': theme_palette_1.ColorPalette2022Branding.lightRed,
        border: '1px solid #FFFFFF',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'margin-left': theme_1.DefaultTheme.space(1),
        'flex-shrink': '0',
    },
    [exports.CSS.isEmpty]: {
        color: theme_1.DefaultTheme.font.color.disabled,
    },
    [`${exports.CSS.isEmpty} ${exports.CSS.form.header}`]: {
        padding: 0,
    },
});
//# sourceMappingURL=collection.view.style.js.map